/**
 * Employees Portfolio constants.
 */

export const EMPLOYEE_ID_PARAMETER_NAME = 'employee-id';
